import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendGetRequest } from '../../api/requestUtil';
// import { sendGetRequest } from './requestUtil';

// Use your existing global types for search results
// UnifiedSearchResultType, BlogSearchResult, BlogPostSearchResult, FeaturedArticleSearchResult

export interface SearchMetadata {
  phrases: string[];
  words: string[];
  content_types_searched: string[];
}

export interface SearchResponse {
  count: number;
  page: number;
  page_size: number;
  total_pages: number;
  next: number | null;
  previous: number | null;
  results: UnifiedSearchResultType[];
  search_metadata?: SearchMetadata;
}

export type SearchBlogsParams = {
  query: string;
  page?: string | number;
  page_size?: string | number;
  content_types?: string;
};

export const searchBlogs = createAsyncThunk<SearchResponse, SearchBlogsParams>(
  'search-blogs',
  async (params: SearchBlogsParams) => {
    const { query, page = 1, page_size = 20, content_types } = params;

    const queryParams = new URLSearchParams();
    queryParams.append('query', query);
    queryParams.append('page', String(page));
    queryParams.append('page_size', String(page_size));

    if (content_types) {
      queryParams.append('content_types', content_types);
    }

    return await sendGetRequest(`/api/search/?${queryParams.toString()}`);
  }
);

// // Helper function to build search query with phrases
// export const buildSearchQuery = (terms: string[]): string => {
//   return terms
//     .map(term => {
//       // If term contains spaces, wrap in quotes for phrase search
//       return term.includes(' ') ? `"${term}"` : term;
//     })
//     .join(' ');
// };

// // Helper to check if a query uses phrase search
// export const hasPhraseSyntax = (query: string): boolean => {
//   return /["']/.test(query);
// };

// // Helper to extract phrases from a query (client-side parsing)
// export const parseSearchQuery = (query: string): { phrases: string[]; words: string[] } => {
//   const phrasePattern = /"([^"]+)"/g;
//   const phrases: string[] = [];
//   let match;

//   while ((match = phrasePattern.exec(query)) !== null) {
//     phrases.push(match[1]);
//   }

//   // Remove quoted phrases and get remaining words
//   const remaining = query.replace(phrasePattern, '').trim();
//   const words = remaining.split(/\s+/).filter(w => w.length > 0);

//   return { phrases, words };
// };

// // Type guard functions for search results
// export const isBlogResult = (result: UnifiedSearchResultType): result is BlogSearchResult => {
//   return result.type === 'blog';
// };

// export const isBlogPostResult = (result: UnifiedSearchResultType): result is BlogPostSearchResult => {
//   return result.type === 'blog_post';
// };

// export const isFeaturedArticleResult = (result: UnifiedSearchResultType): result is FeaturedArticleSearchResult => {
//   return result.type === 'featured_article';
// };

// // Helper to get image URL from any search result type
// export const getResultImage = (result: UnifiedSearchResultType): string | null => {
//   if (isBlogResult(result) || isFeaturedArticleResult(result)) {
//     return result.image_blog_page;
//   }
//   if (isBlogPostResult(result) && result.blog) {
//     return result.blog.image_blog_page;
//   }
//   return null;
// };

// // Helper to get result URL
// export const getResultUrl = (result: UnifiedSearchResultType): string => {
//   if (isBlogResult(result)) {
//     return result.url;
//   }
//   if (isBlogPostResult(result)) {
//     return result.link;
//   }
//   if (isFeaturedArticleResult(result)) {
//     return result.url;
//   }
//   return '#';
// };

// // Helper to get formatted date
// export const getResultDate = (result: UnifiedSearchResultType): string | null => {
//   if (isBlogResult(result)) {
//     return result.created_on;
//   }
//   if (isBlogPostResult(result)) {
//     return result.published_date;
//   }
//   if (isFeaturedArticleResult(result)) {
//     return result.published_date || result.created_on;
//   }
//   return null;
// };

// // Helper to get description/summary
// export const getResultDescription = (result: UnifiedSearchResultType): string => {
//   if (isBlogResult(result) || isFeaturedArticleResult(result)) {
//     return result.description;
//   }
//   if (isBlogPostResult(result)) {
//     return result.summary || '';
//   }
//   return '';
// };

// // Helper to format date nicely
// export const formatResultDate = (result: UnifiedSearchResultType): string => {
//   const dateStr = getResultDate(result);
//   if (!dateStr) return '';

//   const date = new Date(dateStr);
//   return date.toLocaleDateString('en-US', {
//     year: 'numeric',
//     month: 'short',
//     day: 'numeric'
//   });
// };
